import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {DynamicSlotName} from '../../../../lib/DynamicSlotName'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {DynamicSlot} from '../../../dynamic/DynamicSlot'
import {IconOk} from '../../../ui/Icons'
import {RetryPayment} from './RetryPayment'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionCancelled = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const title = api.trans('blocks.subscription_cancelled.subtitle')
  const textHTML = api.trans('blocks.subscription_cancelled.text_html')
  const retryPaymentText = api.trans(
    'blocks.subscription_cancelled.retry_payment',
  )
  const showRetryPaymentButton = api.resolveConfigWithSingleResult<boolean>(
    'showRetryPaymentButton',
  )

  return (
    <div className="subscription-cancelled">
      <div className="header">
        <div className="title">
          <IconOk />
          <h2 className="text">{title}</h2>
        </div>
      </div>

      <DynamicSlot name={DynamicSlotName.SUBSCRIPTION_CANCELLED_START} />

      <div className="main" dangerouslySetInnerHTML={{__html: textHTML}} />

      {showRetryPaymentButton && (
        <div className="actions">
          <RetryPayment
            text={retryPaymentText}
            className="retry-payment-line"
          />
        </div>
      )}

      <DynamicSlot name={DynamicSlotName.SUBSCRIPTION_CANCELLED_END} />
    </div>
  )
})
